import { useGet } from 'hooks/use-get';
import { getFeed } from '../api/get-feed';
import React, { useContext, useMemo } from 'react';

import { useAccountState } from 'contexts/account/account-context';
import { Feed } from 'views/self-service/features/feed-catalog/types/feed.type';

type State = {
  isLoading: boolean;
  feedCodes: string[];
  allFeeds: Feed[] | undefined;
};

const FeedCatalogContext = React.createContext<State | undefined>(undefined);

type FeedCatalogProviderProps = {
  children: React.ReactNode;
};

const FeedCatalogProvider: React.FC<FeedCatalogProviderProps> = ({ children }) => {
  const { account } = useAccountState();

  const { data: allFeeds, isLoading } = useGet(['getFeed'], () => getFeed(String(account.company!.companyId)), {
    enabled: !!account.company!.companyId,
  });

  const feedCodes = useMemo(() => allFeeds?.map((feed) => feed?.code).filter((code): code is string => code != null) ?? [], [allFeeds]);

  return <FeedCatalogContext.Provider value={{ feedCodes, allFeeds, isLoading }}>{children}</FeedCatalogContext.Provider>;
};

function useFeedCatalogState() {
  const context = useContext(FeedCatalogContext);
  if (context === undefined) {
    throw new Error('useFeedCatalogState must be used within a FeedCatalog provider');
  }
  return context;
}

export { FeedCatalogProvider, useFeedCatalogState };
